// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux
import { every,isNull, mapValues } from 'lodash';

// Action Types
export const typePrefix = 'vra/validations/';
export const actions = [
  'SET_VALIDATION_RESULT',
  'RESET_VALIDATION_RESULT'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});


// Reducer

export default function reducer(
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_VALIDATION_RESULT:
      return {
        ...state,
        ...action.payload
      };
    case actions.RESET_VALIDATION_RESULT:
      return {};
    default:
      return state;
  }
}

// Action Creators
export const setValidationResult = ({ key, resultedFromUserInput=true, rawValidatorResult }) => {
  return (dispatch) => {
    rawValidatorResult = rawValidatorResult || {};
    const resultsByKey = mapValues(rawValidatorResult, (helpMessages) => {
      return {
        helpMessages: helpMessages || [],
        isInvalid: !isNull(helpMessages),
        resultedFromUserInput
      };
    });

    dispatch({
      type: actions.SET_VALIDATION_RESULT,
      payload: {
        [key]: {
          isInvalid: !every(rawValidatorResult, isNull),
          resultedFromUserInput,
          resultsByKey
        }
      }
    });
  };
};

export const resetValidationResults = () => {
  return { type: actions.RESET_VALIDATION_RESULT };
};
